import { setShippingAddress } from "@/services/checkout";
import { getCookies } from "cookies-next";
import toast from "react-hot-toast";

export const handleShippingAddress = async (address, dispatch) => {
  const { handshake, mage, quote } = getCookies();
  const { data, error } = await setShippingAddress(
    handshake,
    mage,
    quote,
    address
  );

  if (error === null) {
    toast.success(data?.message);
    dispatch({ type: "shipping_address", payload: address });
    dispatch({ type: "cart", payload: data?.data?.totals });
    dispatch({ type: "payments", payload: data.data?.payment_methods });
    dispatch({ type: "isShipping_address_submiting", payload: true });
    return true;
  }
  toast.error(error?.error?.message);
  return false;
};
